import { Link, Navigate } from 'react-router-dom';

import { useAuth } from '../../../context/AuthContext';

import { useIntl } from 'react-intl';

import Button from '../../../shared/ui/button/button';

import { NotFound as PageNotFound } from '../../../shared/assets/icons';

import styles from './not-found.module.css';

export function NotFound() {
	const { isAuth, isLoading } = useAuth();

	const intl = useIntl();

	if (isLoading) {
		return <div>Loading...</div>;
	}

	if (isAuth) {
		return <Navigate to='/overview' replace />;
	}

	return (
		<div className={styles.page}>
			<div className={styles.contoursRight} />
			<div className={styles.contoursLeft} />

			<div className={styles.content}>
				<PageNotFound />

				<p className={styles.title}>
					{intl.formatMessage({ id: 'NotFoundID1' })}
				</p>

				<p className={styles.description}>
					{intl.formatMessage({ id: 'NotFoundID2' })}
				</p>

				<Button to='/' className={styles.homeButton}>
					{intl.formatMessage({ id: 'NotFoundID3' })}
				</Button>

				<p className={styles.help}>
					<span className={styles.helpText}>
						{intl.formatMessage({ id: 'NotFoundID4' })}
					</span>
					<Link to='/contact' className={styles.supportLink}>
						{intl.formatMessage({ id: 'NotFoundID5' })}
					</Link>
				</p>
			</div>
		</div>
	);
}
